// page cocon

    if (window.location.href.indexOf("guide-races-chiens-") > -1 || window.location.href.indexOf("races-guide-chats-") > -1) {
      if (ShopifyAnalytics.meta.page.customerId != undefined) {
        
        var body = document.body, html = document.documentElement;
        var alreadyExecuted = false;
        var pageHeight = Math.max( body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight );

        var myScrollFunc = function() {
            var y = window.scrollY;

            if (y >= (pageHeight / 2) && alreadyExecuted != true) {
                var coconTag = document.querySelector('main').getAttribute('data-cocon');
                console.log('half way there, ', coconTag);
                alreadyExecuted = true;
                var data_make =  {
                  "shopify_customer_id": ShopifyAnalytics.meta.page.customerId,
                  "cocon_tag": coconTag,
                }
        
                fetch("https://hook.eu1.make.com/gauvvi5f0q5mkackwyjmbjli789jtwt4", {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify(data_make)
                })
                .then(response => {
        
                })
                .catch((error) => {
                  console.error('Error:', error);
                });
            }
        };
        
        window.addEventListener("scroll", myScrollFunc);
      }
    }

    // accordions

    function recalculateCoconAccordions() {
      document.querySelectorAll('.has-accordion h3').forEach(function (title) {
        var accordionDesc = title.nextElementSibling;
        if (!accordionDesc || !accordionDesc.classList.contains('accordion-description')) return;
        if (!title.classList.contains('active')) return;
        accordionDesc.style.maxHeight = (accordionDesc.scrollHeight + 32) + 'px';
        accordionDesc.style.height = (accordionDesc.scrollHeight + 32) + 'px';
      });
    }

    window.recalculateCoconAccordions = recalculateCoconAccordions;

    var accordionTitles = document.querySelectorAll('.has-accordion h3');
    if (accordionTitles.length > 0) { 
      const shouldOpenByDefault = document.querySelector('.open-accordions-default');
      
      accordionTitles.forEach(title => {
        // Find all consecutive `.accordion-description` elements
        let accordionDescription = title.nextElementSibling;
        let mergedContent = ''; // Store merged content

        // Merge content of consecutive `.accordion-description` elements
        while (accordionDescription && accordionDescription.classList.contains('accordion-description')) {
          mergedContent += accordionDescription.innerHTML;
          let nextSibling = accordionDescription.nextElementSibling;
          
          // Remove extra `.accordion-description` elements
          if (mergedContent !== accordionDescription.innerHTML) {
            accordionDescription.remove();
          }

          accordionDescription = nextSibling;
        }

        // Set merged content to the first `.accordion-description` after each `<h3>`
        if (title.nextElementSibling && title.nextElementSibling.classList.contains('accordion-description')) {
          title.nextElementSibling.innerHTML = mergedContent;
        }

        // Accordion toggle logic
        title.addEventListener('click', () => {
          let accordionDesc = title.nextElementSibling;
          if (!accordionDesc || !accordionDesc.classList.contains('accordion-description')) return;
          if (!title.classList.contains('active')) {
            title.classList.add('active');
            accordionDesc.style.maxHeight = (accordionDesc.scrollHeight + 32) + "px";
            accordionDesc.style.height = (accordionDesc.scrollHeight + 32) + "px";
          } else {
            title.classList.remove('active');
            accordionDesc.style.maxHeight = 0;
            accordionDesc.style.height = null;
          }
        });

        // Optional: Open accordion if it contains a specific element
        if (title.nextElementSibling && title.nextElementSibling.querySelector(".slider-cocon_slider")) {
          if (!window.location.href.includes("alimentation")) {
            setTimeout(() => {
              title.click();
            }, 500);
          } else {
            const elementToMove = document.querySelector('.cocon-text__slider-container');

            // Select the parent element
            const parentElement = elementToMove.parentElement;

            // Move the element by appending it after the parent
            if (elementToMove && parentElement) {
                parentElement.after(elementToMove);
            }
          }
        }
        
        // Open all accordions by default if the option is enabled
        if (shouldOpenByDefault) {
          setTimeout(() => {
            title.click();
          }, 100);
        }
      });

      if (shouldOpenByDefault) {
        setTimeout(recalculateCoconAccordions, 150);
      }
    }
